import React from 'react';
import { applyStyles } from 'util/helpers';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import Jump from 'components/common/Jump';
import Web from './components/Web';
import Phone from './components/Phone';
import i18n from 'i18n';
import Colors from 'constants/colors';
import Breadcrumbs from 'components/common/Breadcrumbs';
import GrayHeader from 'components/common/GrayHeader';

const aboutPayment = ({ className, location: { pathname } }) => (
  <div className={className}>
    <GrayHeader text={i18n.t('about:gift:grayHeader')} />
    <Breadcrumbs currentPath={pathname} />
    <Jump />
    <section>
      <Web />
    </section>
    <section>
      <Phone />
    </section>
  </div>
);

const commonStyle = css`
  p {
    margin-bottom: 0;
  }
  section {
    border-bottom: 1px solid ${Colors.gray2};

    &:last-child {
      border-bottom: none;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 886px;
  margin-left: auto;
  margin-right: auto;

  ${Breadcrumbs} {
    margin-top: 12px;
  }

  p {
    margin-top: 36px;
    margin-bottom: 0px;
  }

  section {
    padding-bottom: 72px;

    &:last-child {
      padding-bottom: 155px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;

  ${Breadcrumbs} {
    margin-top: 6px;
  }

  section {
    padding-bottom: 48px;
  }
`;

export default applyStyles(aboutPayment)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Gift/index.js